import { format, parseISO } from 'date-fns';
import React from 'react';

import { IWheelOfFortuneHistoryItem } from 'models/wheel-of-fortune/i-wheel-of-fortune';

import { prizeAmount, rewardKindOf } from '../prizeToWheelData';
import EventNameRow from './EventNameRow';
import RewardRow from './RewardRow';
import TypeRow from './TypeRow';

interface WheelOfFortuneHistoryTableRowProps {
  item: IWheelOfFortuneHistoryItem;
}

const WheelOfFortuneHistoryTableRow: React.FC<WheelOfFortuneHistoryTableRowProps> = ({ item }) => {
  const formattedDate = format(parseISO(item.created_at), 'dd-MM-yyyy HH:mm');
  const eventType = item.type === 'out' ? 'spin' : 'event';
  const isSpin = item.type === 'out';

  const reward = isSpin ? (item.reward ? prizeAmount(item.reward.prize) : '-') : item.amount.toString();

  // A DEBIT is labelled by the prize it won. A CREDIT has no prize, so its label comes
  // from the balance it landed in — this used to be hardcoded 'wof', which printed
  // "2 WoF Spins" for VIP spins earned from a level-up or bought in the shop. Rows from
  // before the VIP wheel have no spin_kind and keep the generic label.
  const creditType = item.spin_kind === 'vip' ? 'vip_wof_spins' : 'wof';
  const rewardType = isSpin && item.reward ? rewardKindOf(item.reward.prize) : creditType;

  return (
    <div className="tw-flex tw-items-center tw-justify-start tw-gap-[5px] tw-rounded-[10px] tw-bg-blue-900 tw-p-2.5 lg:tw-gap-5">
      <div className="tw-flex-1 tw-rounded-[5px] tw-bg-[#232589] tw-py-[10px] tw-text-center tw-text-[8px] tw-font-bold tw-text-white lg:tw-bg-transparent lg:tw-py-0 lg:tw-text-[18px]">
        {formattedDate}
      </div>
      <TypeRow type={eventType} />
      <RewardRow reward={reward} rewardType={rewardType} />
      <EventNameRow sourceName={item.source_name} />
    </div>
  );
};

export default WheelOfFortuneHistoryTableRow;
